import { Component, Input, Output, EventEmitter, ViewChild, OnInit, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'icc-fake-textarea',
  templateUrl: './icc-fake-textarea.component.html',
  styleUrls: ['./icc-fake-textarea.component.less'],
})
export class IccFakeTextAreaComponent implements OnInit, OnChanges {
  constructor(private cdr: ChangeDetectorRef) {}

  @ViewChild('mockTextarea', { static: false }) mockTextarea;

  // value: 整个模版包含 content 和 pasterList，用于自动匹配时回显
  @Input() isTplEdit: boolean;
  @Input() value = '';
  @Input() pasterList = [];
  // @Input() shortLinkList = [];
  // 如果添加了贴片 config 上会存在 uuid 或者 requiredShortUrl 为 true
  // @Input() uuid = null;
  @Input() targetUrl = null; // 融合发送
  @Input() serverUrl = null; // 模版编辑
  @Input() height = 150;
  @Input() maxlength = 500;
  @Input() placeholder = '';
  // 是否禁用
  @Input() isDisabled = false;
  @Output() valueChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() emitCursorOffset: EventEmitter<any> = new EventEmitter<any>();

  // textarea 中显示的贴片和短链数组
  textareaPasterList = [];
  textareaShortLinkList = [];

  replaceArray = [];

  // displayValue() 函数调用的次数
  displayIndex: number = 0;

  // 鼠标从textarea移出之后的光标位置
  cursorOffset = 0;

  oldValue: string = '';

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.value) {
      setTimeout(() => {
        this.displayValue(changes.value.currentValue);
      }, 100);
    }
    // 只有在 pasterList 增加的时候 或者 新增短链的时候 才会触发 addDom，用来避免删除贴片时造成的死循环
    // 先改变innnerText，再根据innnerText改为对应的innnerHTML

    // pasterList 增加时：
    if (changes.pasterList && changes.pasterList.currentValue && (changes.pasterList.previousValue === null || (changes.pasterList.previousValue && changes.pasterList.previousValue.length < changes.pasterList.currentValue.length))) {
      if (this.mockTextarea && this.mockTextarea.nativeElement) {
        // 插入贴片  -  innerText
        let { innerText } = this.mockTextarea.nativeElement;
        let groupName = this.pasterList.length > 0 ? this.pasterList[this.pasterList.length - 1].groupName : '';
        let text_pluginPaster = '${' + groupName + '}';
        innerText = innerText.slice(0, this.cursorOffset) + text_pluginPaster + innerText.slice(this.cursorOffset);
        this.mockTextarea.nativeElement.innerText = innerText;
        this.replaceArray.push(groupName);
        this.addToDom(innerText);
        console.log('插入贴片-this.replaceArray:', this.replaceArray);
      }
    }
    // pasterList 减少时：
    if (changes.pasterList && changes.pasterList.previousValue && changes.pasterList.currentValue && changes.pasterList.previousValue.length > changes.pasterList.currentValue.length) {
      // 先找出被删除的贴片列表
      let deletePasterList = changes.pasterList.previousValue.filter(item => {
        return changes.pasterList.currentValue.indexOf(item) < 0;
      });
      for (let i = 0; i < deletePasterList.length; i++) {
        let item = deletePasterList[i].groupName;
        for (let j = 0; j < this.replaceArray.length; j++) {
          if (item === this.replaceArray[j]) {
            this.replaceArray.splice(j, 1);
          }
        }
      }
      console.log('删除贴片-this.replaceArray:', this.replaceArray);
    }

    // targetUrl 添加时（融合发送）
    if (changes.targetUrl && changes.targetUrl.currentValue && changes.targetUrl.currentValue !== changes.targetUrl.previousValue) {
      if (this.value === '' && this.replaceArray) {
        this.replaceArray = [];
      }
      if (this.mockTextarea && this.mockTextarea.nativeElement) {
        // 插入短链  -  innerText
        let { innerText } = this.mockTextarea.nativeElement;
        innerText = innerText.slice(0, this.cursorOffset) + changes.targetUrl.currentValue + '${traceCode}' + innerText.slice(this.cursorOffset);
        this.mockTextarea.nativeElement.innerText = innerText;
        this.replaceArray.push(changes.targetUrl.currentValue + '${traceCode}');
        this.addToDom(innerText);
        console.log('添加短链-this.replaceArray:', this.replaceArray);
      }
    }

    // targetUrl 减少时
    if (changes.targetUrl && !changes.targetUrl.currentValue && changes.targetUrl.previousValue) {
      for (let i = 0; i < this.replaceArray.length; i++) {
        let item = this.replaceArray[i];
        if (item.includes('${traceCode}')) {
          this.replaceArray.splice(i, 1);
        }
      }
      console.log('删除短链-this.replaceArray:', this.replaceArray);
    }

    // serverUrl 添加时（模版编辑）
    if (changes.serverUrl && changes.serverUrl.currentValue && changes.serverUrl.currentValue !== changes.serverUrl.previousValue) {
      if (this.value === '' && this.replaceArray) {
        this.replaceArray = [];
      }
      if (this.mockTextarea && this.mockTextarea.nativeElement) {
        // 插入短链  -  innerText
        let { innerText } = this.mockTextarea.nativeElement;
        innerText = innerText.slice(0, this.cursorOffset) + '${短链接}' + innerText.slice(this.cursorOffset);
        this.mockTextarea.nativeElement.innerText = innerText;
        this.replaceArray.push('${短链接}');
        this.addToDom(innerText);
        console.log('添加短链-this.replaceArray:', this.replaceArray);
      }
    }

    // serverUrl 减少时
    if (changes.serverUrl && !changes.serverUrl.currentValue && changes.serverUrl.previousValue) {
      for (let i = 0; i < this.replaceArray.length; i++) {
        let item = this.replaceArray[i];
        if (item.includes('${短链接}')) {
          this.replaceArray.splice(i, 1);
        }
      }
      console.log('删除短链-this.replaceArray:', this.replaceArray);
    }
  }

  addToDom(innerText) {
    this.replaceArray.forEach(item => {
      let _pasterName = '';
      if (item.includes('${traceCode}') || item.includes('${短链接}')) {
        _pasterName = item;
      } else {
        _pasterName = '${' + item + '}';
      }
      let html_pluginPaster = `<span class="innerPaster" style="vertical-align: middle;display: inline-block;margin: 0 5px;border: 1px solid #b8e5f5;width: auto;height: 21px;background: rgba(184, 229, 245, .14);-moz-user-select: none;-webkit-user-select: none;-ms-user-select: none;-khtml-user-select: none;user-select: none;" contenteditable="false">${_pasterName}</span> `;
      let pasterOffset = innerText.indexOf(_pasterName);
      innerText = innerText.slice(0, pasterOffset) + html_pluginPaster + innerText.slice(pasterOffset + _pasterName.length);
    });

    this.mockTextarea.nativeElement.innerHTML = innerText;
    // addDOM 时候也 发出当前 value，通知父组件修改 value 和 贴片列表 & 短链列表
    this.emitValue();
    this.moveFocus();
  }

  // 编辑时，光标位置移动到最后
  moveFocus() {
    let el = this.mockTextarea.nativeElement;
    el.focus();
    let range = document.createRange();
    range.selectNodeContents(el);
    range.collapse(false);
    let sel = window.getSelection();
    //判断光标位置，如不需要可删除
    if (sel.anchorOffset != 0) {
      return;
    }
    sel.removeAllRanges();
    sel.addRange(range);
  }

  // value改变 发出emit事件
  emitValue() {
    this.value = this.mockTextarea.nativeElement.innerText;
    this.valueChange.emit(this.value);
  }

  // 监听用户输入事件
  handleInputChange($event) {
    // 根据输入属性 maxlength 来判断最大输入值
    let length = this.mockTextarea.nativeElement.innerText.length;
    if (length >= this.maxlength) {
      let innerText = this.mockTextarea.nativeElement.innerText.substring(0, this.maxlength);
      if (this.pasterList && this.pasterList.length > 0) {
        this.pasterList.forEach(paster => {
          // 适配之前的 ${ } 形式
          let $pasterName = '${' + paster.groupName + '}';
          let html_pluginPaster = `<span class="innerPaster" style="vertical-align: middle;display: inline-block;margin: 0 5px;border: 1px solid #b8e5f5;width: auto;height: 21px;background: rgba(184, 229, 245, .14);-moz-user-select: none;-webkit-user-select: none;-ms-user-select: none;-khtml-user-select: none;user-select: none;" contenteditable="false">${$pasterName}</span> `;
          let pasterOffset = innerText.indexOf($pasterName);
          innerText = innerText.slice(0, pasterOffset) + html_pluginPaster + innerText.slice(pasterOffset + $pasterName.length);
        });
        this.mockTextarea.nativeElement.innerHTML = innerText;
      } else {
        this.mockTextarea.nativeElement.innerHTML = innerText;
      }
      this.moveFocus();
    }
    // 发出当前 value，通知父组件修改 value 和 贴片列表 & 短链列表
    this.emitValue();
    this.handleBlur();
  }

  // 处理blur事件
  handleBlur() {
    this.getCursorPosition();
    this.emitCursorOffset.emit(this.cursorOffset);
  }

  // 获取光标位置
  getCursorPosition() {
    let element = this.mockTextarea.nativeElement;
    let cursorOffset = 0;
    let doc = element.ownerDocument || element.document;
    let win = doc.defaultView || doc.parentWindow;
    let sel;
    if (typeof win.getSelection != 'undefined') {
      sel = win.getSelection();
      if (sel.rangeCount > 0) {
        let range = win.getSelection().getRangeAt(0);
        let preCaretRange = range.cloneRange();
        preCaretRange.selectNodeContents(element);
        preCaretRange.setEnd(range.endContainer, range.endOffset);
        cursorOffset = preCaretRange.toString().length;
      }
    } else if ((sel = doc.selection) && sel.type != 'Control') {
      let textRange = sel.createRange();
      let preCaretTextRange = doc.body.createTextRange();
      preCaretTextRange.moveToElementText(element);
      preCaretTextRange.setEndPoint('EndToEnd', textRange);
      cursorOffset = preCaretTextRange.text.length;
    }
    this.cursorOffset = cursorOffset;
  }

  // 自动匹配回显操作，解析内容
  displayValue(value) {
    this.displayIndex++;
    // 只有第一次调用displayValue函数的时候才执行回显操作，避免输入时候循环修改content的值
    if (this.displayIndex <= 1 || this.value === '' || this.isDisabled === true) {
      let displayPasterList = this.pasterList;
      let content = value || '';
      if (this.mockTextarea && this.mockTextarea.nativeElement) {
        this.mockTextarea.nativeElement.innerText = content;
        // 先改变innnerText，再根据innnerText改为对应的innnerHTML
        let { innerText } = this.mockTextarea.nativeElement;
        // 1.根据 patchStrategy 判断是否 有贴片存在，有的话用 HTML 替换
        if (displayPasterList && displayPasterList.length > 0) {
          displayPasterList.forEach(paster => {
            // 适配之前的 ${ } 形式
            if (this.replaceArray.indexOf(paster.groupName) < 0) {
              this.replaceArray.push(paster.groupName);
            }
            let $pasterName = '${' + paster.groupName + '}';
            let html_pluginPaster = `<span class="innerPaster" style="vertical-align: middle;display: inline-block;margin: 0 5px;border: 1px solid #b8e5f5;width: auto;height: 21px;background: rgba(184, 229, 245, .14);-moz-user-select: none;-webkit-user-select: none;-ms-user-select: none;-khtml-user-select: none;user-select: none;" contenteditable="false">${$pasterName}</span> `;
            let pasterOffset = innerText.indexOf($pasterName);
            innerText = innerText.slice(0, pasterOffset) + html_pluginPaster + innerText.slice(pasterOffset + $pasterName.length);
          });
        }
        // 2.再根据 serverUrl 或者targetUrl 判断是否 有短链存在，有的话用 HTML 替换
        if ((this.targetUrl || this.serverUrl) && this.value !== '') {
          let urlTag = '';
          if (this.targetUrl) {
            urlTag = this.targetUrl + '${traceCode}';
          }
          if (this.serverUrl) {
            urlTag = '${短链接}';
          }
          if (this.replaceArray.indexOf(urlTag) < 0) {
            this.replaceArray.push(urlTag);
          }
          let html_pluginPaster = `<span class="innerPaster" style="vertical-align: middle;display: inline-block;margin: 0 5px;border: 1px solid #b8e5f5;width: auto;height: 21px;background: rgba(184, 229, 245, .14);-moz-user-select: none;-webkit-user-select: none;-ms-user-select: none;-khtml-user-select: none;user-select: none;" contenteditable="false">${urlTag}</span> `;
          let pasterOffset = innerText.indexOf(urlTag);
          innerText = innerText.slice(0, pasterOffset) + html_pluginPaster + innerText.slice(pasterOffset + urlTag.length);
        }
        // 最后将改变后的innerText直接赋值给innerHTML
        this.mockTextarea.nativeElement.innerHTML = innerText;
      }
    }
  }
}
